import $ from "jquery";
import app from "@@assets/scripts/app";

function showMessageForTestsite($target) {
	if( !($target instanceof $) ) {
		throw new TypeError("arguments[0] must be instance of jQuery");
	}
	
	const { _environment } = app;
	if(_environment !== "test") {
		return false;
	}
	
	$(`
<div style="
background-color: rgba(255, 255, 255, 0.7);
border-style: solid;
border-width: 0 1px 1px 1px;
border-radius: 0 0 10px 10px;
color: red;
font-size: 1.4rem;
font-weight: 500;
left: 50%;
padding: 0 10px;
position: absolute;
top: 0;
transform: translateX(-50%);
white-space: nowrap;
z-index: 999;
">
	<p style="line-height: 2.5rem;">テスト環境を閲覧中です</p>
</div>
	`).prependTo($target);
}

export { showMessageForTestsite };
